export default [
    {
        path: 'unidade',
        component: () => import(
            /* webpackChunkName: 'cadastro-unidade' */
            '@/views/cadastro/unidade/Index'
        ),
        redirect: 'unidade/index',
        children: [
            {
                path: 'index',
                name: 'cadastro-unidade-index',
                component: () => import(
                    /* webpackChunkName: 'cadastro-unidade' */
                    '@/views/cadastro/unidade/List.vue'
                ),
            },
            {
                path: 'create',
                name: 'cadastro-unidade-create',
                component: () => import(
                    /* webpackChunkName: 'cadastro-unidade' */
                    '@/views/cadastro/unidade/Form.vue'
                ),
            },
            {
                name: 'cadastro-unidade-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'cadastro-unidade' */
                    '@/views/cadastro/unidade/Form.vue'
                ),
            },
        ],
    },
]